// extracted by mini-css-extract-plugin
export default {"Container":"Skeleton_Container__s0Thq","left":"Skeleton_left__5FxaV","right":"Skeleton_right__uGyEe"};